import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=1324be14"
import script from "./Message.vue?vue&type=script&setup=true&lang=js"
export * from "./Message.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports